import React, { useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUserChat } from "../../services/UserServices/UserService";
import {
  Button,
 
} from "react-bootstrap";
export default function ChatUI() {
  const [chat, setChat] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);
const lastMessageRef = useRef(null);
  const fetchChat = async () => {
    try {
      const res = await getUserChat(
       id
      );

      setChat(
        res?.data?.data?.sort(
          (a, b) =>
            new Date(a.messageTime) -
            new Date(b.messageTime)
        )
      );

      console.log(res?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchChat();
  }, []);
  useEffect(() => {
  lastMessageRef.current?.scrollIntoView({
    behavior: "smooth",
  });
}, [chat]);

  const sender = chat?.[0]?.sender;
  console.log("here",sender);
  const receiver = chat?.[0]?.receiver?.[0]?.user;
 console.log("thee" ,receiver);
  return (
    <div
      className="container-fluid py-4"
      style={{
      
        minHeight: "100vh",
      }}
    >
  <Button
                  variant="light"
                  size="sm"
                  className="mb-2 shadow-sm"
                  onClick={() =>   navigate(-1)}
                >
                  &larr; Back
                </Button>
      <div
        className="card border-0 shadow-lg"
        style={{
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
         
        <div
          className="d-flex justify-content-between align-items-center p-3"
          style={{
            background: "#E5484D",
          }}
        >
          <div className="d-flex align-items-center">
            <img
              src={sender?.image}
              alt=""
              width="55"
              height="55"
              className="rounded-circle border border-3 border-white"
              style={{
                objectFit: "cover",
              }}
            />

            <div className="ms-3">
              <h5 className="text-white mb-0">
                {sender?.name}
              </h5>

              <small className="text-white">
                Sender
              </small>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <div className="text-end me-3">
              <h6 className="text-white mb-0">
                {receiver?.name.charAt(0).toUpperCase() + receiver?.name.slice(1)}
              </h6>

              <small className="text-white">
                Receiver
              </small>
            </div>

            <img
              src={receiver?.image}
              alt=""
              width="55"
              height="55"
              className="rounded-circle border border-3 border-white"
              style={{
                objectFit: "cover",
              }}
            />
          </div>
        </div>

        {/* CHAT BODY */}
        <div
          ref={chatContainerRef}
          style={{
            background:
              "url('https://www.transparenttextures.com/patterns/cubes.png')",
            height: "75vh",
            overflowY: "auto",
            padding: "25px",
          }}
        >
        {chat?.map((msg,index) => {
  const isSender = msg.sender?._id === sender?._id;

  return (
    <div
      key={msg._id}
        ref={
        index === chat.length - 1
          ? lastMessageRef
          : null
      }
      className={`d-flex mb-4 ${
        isSender
          ? "justify-content-start"
          : "justify-content-end"
      }`}
    >
      {/* Sender Message */}
      {isSender && (
        <img
          src={msg.sender?.image}
          alt=""
          width="40"
          height="40"
          className="rounded-circle me-2"
          style={{ objectFit: "cover" }}
        />
      )}
    <div
        style={{
          maxWidth: "70%",
        }}
      >
        <div
          className="shadow-sm"
          style={{
            background: isSender
              ? "#fff"
              : "#E5484D",
            color: isSender
              ? "#000"
              : "#fff",
            padding: "12px 16px",
            borderRadius: isSender
              ? "0px 18px 18px 18px"
              : "18px 0px 18px 18px",
            borderLeft: isSender
              ? "4px solid #E5484D"
              : "none",
            borderRight: !isSender
              ? "4px solid #b92e33"
              : "none",
          }}
        >
          <div className="fw-semibold mb-1"
            style={{
              color: isSender
                ? "#E5484D"
                : "#fff",
            }}
          >
            {msg.sender?.name}
          </div>

          <div>{msg.message}</div>

          {msg.image && (
            <img
              src={msg.image}
              alt=""
              className="img-fluid rounded mt-2"
            />
          )}

          {msg.video && (
            <video
              controls
              className="w-100 mt-2 rounded"
            >
              <source src={msg.video} />
            </video>
          )}

          {msg.documentLink && (
            <a
              href={msg.documentLink}
              target="_blank"
              rel="noreferrer"
              className="d-block mt-2"
            >
              📄 View Document
            </a>
          )}

          <div className="d-flex justify-content-between mt-2">
            <small
              className={
                isSender
                  ? "text-muted"
                  : "text-white"
              }
            >
              {new Date(msg.messageTime).toLocaleString("en-IN", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
})}
            </small>

           
          </div>
        </div>
      </div>

      {/* Receiver Message */}
      {!isSender && (
        <img
          src={msg.sender?.image}
          alt=""
          width="40"
          height="40"
          className="rounded-circle ms-2"
          style={{ objectFit: "cover" }}
        />
      )}
    </div>
  );
})}

          {chat?.length === 0 && (
            <div className="text-center text-muted py-5">
              No messages found
            </div>
          )}
        </div>
      </div>
    </div>
  );
}